<template>
    <div class="test-drive__container">
        <div class="test-drive__left-col">
            <picture v-if="image !== false">
                <source type="image/webp" :srcset="image + '&fileType=webp'">
                <img :src="image + '&fileType=png'" class="img-responsive" itemprop="thumbnail" alt="">
            </picture>
            <h2>Book a personalised test drive</h2>
            <p>Please select a date and time which suits you and find out everything you need to know about this {{ vehicle.new_model.model_title }} on a personalised test drive.</p>
        </div>
        <form action="/api/new/test-drive" method="POST" class="test-drive__right-col rd-card rd-card--border-top" @submit.prevent="submitForm" ref="form">
            <div class="form-grid form-grid--xs-1-column" ref="thank-you-message" v-if="submitted">
                <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                    <h2>Thank you for your enquiry</h2>
                    <p>
                        A member of the team will be in touch shortly to discuss your enquiry. If you would like to continue your search or get a free instant valuation please use the links below.
                    </p>
                    <div class="btn-container btn-container--centred btn-container--left-xs btn-container--vertical-xs">
                        <a :href="showroomLink" class="btn btn--primary">Discover more</a>
                        <button type="button" @click="scrollToValuation" class="btn btn--primary-inverted">Value my car</button>
                    </div>
                </div>
            </div>
            <template v-else>
                <h4 class="test-drive__h4 test-drive__h4--first">Please enter your details</h4>
                <div class="form-grid form-grid--xs-1-column">
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <NewTitle />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <FirstName />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <LastName />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <Email />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <Telephone :inputNullable="false" inputValidateMessage="Please enter a telephone number" />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <CustomerLocation />
                    </div>
                </div>
                <h4 class="test-drive__h4">Please choose a dealer</h4>
                <div class="form-grid form-grid--xs-1-column">
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <dealer :filter-new="true" />
                    </div>
                </div>

                <h4 class="test-drive__h4" v-show="haveLocationSelected">Please choose a date</h4>
                <div class="form-grid form-grid--xs-1-column" v-show="haveLocationSelected">
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <div class="test-drive__flatpickr">
                            <input type="text" name="date" ref="date" id="date" class="form-control form-control--select test-drive__select-input" :value="formattedDate" placeholder="Please select a date" data-validate="input" data-validate-message="Please choose a date" />
                            <button type="button" class="test-drive__button-input" @click="toggleDateSelect"></button>
                        </div>
                    </div>
                </div>

                <div class="form-grid form-grid--xs-1-column">
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <privacy></privacy>
                    </div>
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <button type="submit" class="btn btn--primary btn--min-width">Book a test drive</button>
                    </div>
                </div>
            </template>
        </form>
    </div>
</template>

<script>
import NewTitle from "../../../core/components/Forms/Title.vue";
import FirstName from "../../../core/components/Forms/FirstName.vue";
import LastName from "../../../core/components/Forms/LastName.vue";
import Email from "../../../core/components/Forms/Email.vue";
import Telephone from "../../../core/components/Forms/Telephone.vue";
import CustomerLocation from "../../../core/components/Forms/CustomerLocation.vue";
import Dealer from "../../../core/components/Forms/Dealer.vue";
import Privacy from "../../../core/components/Forms/Privacy.vue";
import GenericTextarea from "../../../core/components/Forms/GenericTextarea.vue";
import ContactFormValidator from "../../../validation/ContactFormValidator.js";
import CustomerLocationHandler from "../../../modules/CustomerLocationHandler.js";
import { mapState } from "vuex";
import axios from "axios";
import { addDays, addMonths } from 'date-fns';
const isSameDay = require('date-fns/is_same_day')
import flatpickr from 'flatpickr';
import Swal from 'sweetalert2';

export default {
    components: {
        NewTitle,
        FirstName,
        LastName,
        Email,
        Telephone,
        CustomerLocation,
        Dealer,
        Privacy,
        GenericTextarea
    },
    computed: {
        ...mapState('NewVehicleData', ['vehicle', 'selectedPaint']),
        ...mapState('CustomerData', ['locationId']),
        ...mapState('Finance', ['quote', 'quoteWithPredictableKeys']),
        showroomLink() {
            return `/${this.vehicle.brand}/new/${this.vehicle.new_model.url_model}`;
        },
        image() {
            if (!this.selectedPaint) {
                return false;
            }

            return 'https://cdn.imagin.studio/getImage?customer=robinsandday&zoomType=fullscreen&steering=right&width=800&angle=01&' + this.selectedPaint.url_identifier;
        },
        closedDaysLength() {
            return this.closedDays.length;
        },
        formattedDate() {
            return this.chosenDate ? this.chosenDate.toDateString() : "";
        },
        haveLocationSelected() {
            if (!this.locationId) {
                return false;
            }
            if (this.locationId === null) {
                return false;
            }
            return true;
        }
    },
    data() {
        return {
            validator: null,
            customerLocationHandler: null,
            submitted: false,

            chosenDate: null,
            minDate: null,
            maxDate: null,
            flatpickrInstance: false,
            dayTimes: null,
            selectedTime: null,
            closedDays: [],
        };
    },
    mounted() {
        this.validator = new ContactFormValidator({
            vueForm: true,
            redesign: true,
            element: this.$refs["form"],
        });
        this.customerLocationHandler = new CustomerLocationHandler({
            element: this.$refs["form"],
            additionalLocationFilterFunction: dealer => (dealer.brand == this.vehicle.brand && dealer.codeweavers_key != null && dealer.codeweavers_key.length > 0)
        });

        this.minDate = addDays(new Date(), 2),
        this.maxDate = addMonths(this.minDate, 3);

        this.getDealerClosedDays()
            .then((data) => {
                this.$nextTick(() => {
                    this.initializeDatePicker();
                });
            })
            .catch(errors => {
                console.error(errors);
            });
    },
    watch: {
        locationId: function(newId) {
            this.getDealerClosedDays().then(() => {
                if (!this.flatpickrInstance) {
                    this.initializeDatePicker();
                } else {
                    this.flatpickrInstance.set('disable', [
                        date => {
                            if (!this.haveLocationSelected) {
                                return true;
                            }

                            const closedDaysLength = this.closedDays.length;
                            if (closedDaysLength == 0) {
                                return false;
                            }
                            for (let index = 0; index < closedDaysLength; index++) {
                                if (isSameDay(this.closedDays[index], date)) {
                                    return true;
                                }
                            }

                            return false;
                        },
                    ]);
                }
                const closedDaysLength = this.closedDays.length;
                if (closedDaysLength == 0) {
                    return;
                }
                for (let index = 0; index < closedDaysLength; index++) {
                    if (isSameDay(this.closedDays[index], this.chosenDate)) {
                        this.flatpickrInstance.clear();
                        return;
                    }
                }
            })
        }
    },
    methods: {
        initializeDatePicker() {
            this.flatpickrInstance = flatpickr(this.$refs.date, {
                minDate: this.minDate,
                maxDate: this.maxDate,
                altInput: false,
                dateFormat: "D J F Y",
                locale: {
                    firstDayOfWeek: 1, // start week on Monday
                },
                disableMobile: true,
                disable: [
                    date => {
                        if (!this.haveLocationSelected) {
                            return true;
                        }

                        const closedDaysLength = this.closedDays.length;
                        if (closedDaysLength == 0) {
                            return false;
                        }
                        for (let index = 0; index < closedDaysLength; index++) {
                            if (isSameDay(this.closedDays[index], date)) {
                                return true;
                            }
                        }

                        return false;
                    },
                ],

                onChange: ([date]) => {
                    this.chosenDate = date;
                    // this.$store.commit("setDate", { date: date.toDateString() });
                },
            });
        },

        toggleDateSelect() {
            this.flatpickrInstance.open();
        },

        throwFatalError() {
            Swal.fire({
                title: 'Oops...',
                html: '<p>Something went wrong!</p><a href="/contact-us" class="btn btn--primary">Contact us</a>',
                icon: 'error',
                showConfirmButton: false,
                showCloseButton: false,
                showCancelButton: false,
            });
        },

        getDealerClosedDays() {
            return new Promise((resolve, reject) => {
                if (!this.haveLocationSelected) {
                    reject('No dealer selected');
                    return;
                }

                axios.get('/api/dealer-closed-days', {
                    params: {
                        dealer: this.locationId,
                        service_type: 'Sales',
                    }
                })
                .then((response) => {
                    this.closedDays = response.data;
                    resolve();
                })
                .catch(error => {
                    this.throwFatalError();
                    reject(error);
                });
            });
        },
        async submitForm() {
            if (!await this.validator.isValid()) {
                return;
            }

            const formData = new FormData(this.$refs.form);
            formData.append('vehicle-id', this.vehicle.id);

            this.validator.preventInput();

            axios.post(this.$refs.form.getAttribute('action'), formData)
            .then(response => {
                    this.validator.successResponse();
                    this.submitted = true;
                    this.$nextTick(function() {
                        this.$refs['thank-you-message'].scrollIntoView({ behavior: 'smooth', block: 'center' });
                    });
                })
                .catch(error => {
                    this.validator.errorResponse(error);
                })
        },
        scrollToValuation() {
            this.$emit('scroll-to-valuation');
        },
    }
};
</script>

<style></style>
